/**
 * Almost every Essence title begins with "Essence of (the)". Splitting that
 * prefix into a small eyebrow lets the subject carry the display type, which
 * makes long result lists far easier to scan.
 */

const PREFIX_RE = /^((?:the\s+)?(?:meta-)?essences?\s+of\s+(?:the\s+)?)(.+)$/i;

export interface SplitTitle {
  /** The "Essence of the" part, as written in the source; null when absent. */
  prefix: string | null;
  /** The distinguishing subject, e.g. "Combat Prodigy". */
  subject: string;
}

export function splitEssenceTitle(title: string): SplitTitle {
  const trimmed = title.trim();
  const match = PREFIX_RE.exec(trimmed);
  if (!match) return { prefix: null, subject: trimmed };
  const prefix = match[1].trim().replace(/\s+/g, " ");
  const subject = match[2].trim();
  if (!subject || /^the$/i.test(subject)) return { prefix: null, subject: trimmed };
  return { prefix, subject };
}
